export function listen(
  callBack: (payload: unknown) => void,
  channel: string,
  event: string,
) {
  console.log(`start listen ${channel} ${event}`);
  window.Echo.private(channel).listen(event, (payload: unknown) => {
    console.log('listen event', event);
    console.log('listen payload', payload);
    callBack(payload);
  });

  // return function cleanUp() {
  //   window.Echo.leaveChannel(`private-${channel}`);
  // };
}
